var _path, _path2, _path3, _path4;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgVsc = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  fill: "none",
  viewBox: "0 0 24 24"
}, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
  fill: "#2489CA",
  d: "M2.293 9.052s-.483-.346.096-.809l1.349-1.2s.386-.404.794-.052l12.446 9.378v4.497s-.006.706-.917.628L2.293 9.052Z"
})), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
  fill: "#1070B3",
  d: "m5.504 11.952-3.208 2.902s-.33.244 0 .68l1.49 1.348s.353.379.875-.052l3.401-2.566-2.558-2.312Z"
})), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
  fill: "#0877B9",
  d: "m11.133 11.973 5.883-4.471-.038-4.473s-.251-.976-1.09-.468L8.06 9.652l3.073 2.32Z"
})), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
  fill: "#3C99D4",
  d: "M16.064 21.498c.341.348.756.234.756.234l4.584-2.248c.587-.398.505-.892.505-.892V5.165c0-.59-.607-.794-.607-.794l-3.974-1.906c-.868-.534-1.437.096-1.437.096s.731-.524 1.09.468v17.753a.803.803 0 0 1-.08.35c-.104.21-.33.406-.875.324l.038.042Z"
})));
export default SvgVsc;